export type SocialLogins = 'apple' | 'google' | 'facebook';

export const socialLoginTypes: SocialLogins[] = ['apple', 'google', 'facebook'];

export const socialLoginSettingKeys:Record<SocialLogins, string> = {
  google: 'googleLogin',
  facebook: 'facebookLogin',
  apple: 'appleLogin'
}
